export const packageId = 10 as number;
export const packageInfo = 'com.sambad.99lotto';
export const defaultChannel = 'rupiibet';
export const disabledPhoneCode = true;
export const apiSendPhoneCode = false;
export const defaultPhoneCode = '91';
export const homePage = 'Index';
export const gameNavigateVersion = 1;
